import { API_URL } from "../constants";
import axios from "axios";

export async function setMeetingPlace(params) {
  const response = await axios.post(`${API_URL}/ChangeMeetingPlace`, params);
  const data = await response;

  return data.data;
}
